import React, { useEffect, useState } from "react";
import HomeIcono from "../../components/HomeIcon/HomeIcono";
import styles from "./CirculosEstudio.module.css";
import codigodelfin from "../../resources/img/elcodigo.webp";
import CursoCard from "../../components/CursoCard/CursoCard";
import CodigoFin from "./CodigoFin/CodigoFin";


const CirculosEstudio: React.FC = () => {
  const [cursoToRender, setCursoToRender] = useState<number>(0);
  const [periodoUsuario, setPeriodoUsuario] = useState<string>("Enero 2026");


  useEffect(() => {}, []);

  const setCursoToRenderById = (id: number ) => {
    setCursoToRender(id);
  }

  // (podemos traer esto de una API)
  const circles = [
    { id: 1, title: "El Código Del Fin", img: codigodelfin, url: "codigofin" }
  ];

  return ( <> 
    { cursoToRender == 0 ?
      <div className={styles.pageContainer}>
              <HomeIcono />

            <div className={styles.headerContainer}>
              <h1 className={styles.mainTitle}>CÍRCULOS DE ESTUDIO</h1>
              <h3 className={styles.subTitle}>
                "Abre mis ojos para que vea las verdades maravillosas que hay en tus enseñanzas."
                <br />
                <span style={{ fontWeight: "bold" }}>(Salmo 119:18 NTV)</span>
              </h3>
            </div>

            {/* Grid de cursos */}
            <div className={styles.gridContainer}>
              {circles.map((circle, index) => (
                <CursoCard 
                  key={index} 
                  title={circle.title} 
                  imageSrc={circle.img}
                  idCurso={circle.id}
                  setCursoToRenderById={setCursoToRenderById}
                  setPeriodoUsuario={setPeriodoUsuario}
                />
              ))}
            </div>
          </div> :
          cursoToRender === 1 ? <CodigoFin  onBack={() => setCursoToRender(0)} periodo={periodoUsuario}/> :
          null // Or a default component if cursoToRender is not 0 or 1
    } 
    </>
  );
};

export default CirculosEstudio;
